import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import theme from "../theme/theme";
import ButtonComponent from "./ButtonComponent";
import EmployeeCard from "./EmployeeCard";
import "../assets/styles/profile-page.css";
import { useNavigate } from "react-router-dom";
import { routePath } from "../routes/routePath";
import { formatDate } from "../utilities/formatDate";
import { updatePasswordAsync } from "../services/employeeService";
import showSweetAlert from '../components/SweetAlert';

const EmpDisplayProfile = ({ employee, handleEdit }) => {
  const [show, setShow] = useState(false);
  const [selectedDeptPos, setSelectedDeptPos] = useState("");
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [resetLoading, setResetLoading] = useState(false);
  const [resetError, setResetError] = useState(null);

  const navigate = useNavigate();

  const passwordFormRef = useRef(null);
  const cardRef = useRef();


  const handleMyRequests=(empId)=>{
    navigate(routePath.empRequests(empId))
  }
  const handleShow = () => {
    if (employee.deptPos.length === 1) {
      setSelectedDeptPos(employee.deptPos[0]);
      setShow(true);
    } else if (employee.deptPos.length > 1) {
      setShow(true);
    } else {
      return;
    }
  };

  const handleSelectDeptPos = (deptPosId) => {
    const chosenDeptPos = employee.deptPos.find(
      (pos) => pos.deptPosId === deptPosId
    );
    setSelectedDeptPos(chosenDeptPos);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedDeptPos(null);
  };
  const handlePrint = () => {
    const printContents = cardRef.current.innerHTML;
    const printWindow = window.open("", "_blank");
    printWindow.document.write("<html><head><title>طباعة</title>");
    printWindow.document.write(`
      <style>
        body { font-family: 'Tajawal', sans-serif; direction: rtl; }
        .employee-card {
          background: #aa9a73 !important;
          color: white !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        .profile-info-row {
          text-align: right;
          font-size: 12px;
          background: black !important;
          color: white !important;
        }
        .pcard-empNumber {
          color: white !important;
        }
      </style>
    `);
    printWindow.document.write("</head><body>");
    printWindow.document.write(printContents);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    };
  };
 
    const openPasswordUpdateForm = () => {
    setShowPasswordForm(true);
    setTimeout(() => {
      passwordFormRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 100); // slight delay to ensure render
  };

  const handleCancelPasswordUpdate = () => {
    setCurrentPassword("")
    setNewPassword("")
    setConfirmNewPassword("")
    setResetError("")
    setShowPasswordForm(false);
  };

  const handleUpdatePassword = async () => {
    setResetError("");

    if (newPassword !== confirmNewPassword) {
      setResetError("تأكيد كلمة المرور غير متطابق");
      return;
    }
  
    const payload = {
      oldPassword: currentPassword,
      newPassword,
    };

    setResetLoading(true);
    try {
      // V2 returns an empty 200 on success; a resolved call means it worked.
      await updatePasswordAsync(payload);
      showSweetAlert("تم تحديث كلمة المرور بنجاح");
      setShowPasswordForm(false);
      setCurrentPassword("");
      setNewPassword("");
      setConfirmNewPassword("");
    } catch (error) {
      showSweetAlert(error?.message || "حدث خطأ أثناء تحديث كلمة المرور");
    } finally {
      setResetLoading(false);
    }
  };

  return (
    <div>
      <div className="profile-container shadow-box col-12 d-flex flex-column align-items-center p-4 m-auto">
        <div className="profile-header d-flex flex-column align-items-center mb-4">
          <FontAwesomeIcon icon={faUser} fontSize={50} className="mb-3" />
          <h2 className="mb-1">{employee.name}</h2>
          <p style={{ color: theme.colors.darkGray }}>
            <span>الاقسام/المناصب : </span>
          </p>
          <ul className="department-positions-list">
            {employee.deptPos.map((item) => (
              <li key={item.deptPosId}>
                <strong>{item.deptName}:</strong> {item.posTitle}
              </li>
            ))}
          </ul>
          <p style={{ color: theme.colors.darkGray }}>
            <span>المؤهل: </span>
            {employee.qualification}
          </p>
        </div>

        <div className="profile-info container col-sm-10 col-12 mb-4">
          <div className="profile-info-row d-flex flex-column flex-sm-row justify-content-between shadow-box p-3 mb-3">
            <span>الجنس: </span>
            <span>
              {employee.gender === "male" ? "ذكر" : "انثى" || "لايوجد"}
            </span>
          </div>

          <div className="profile-info-row d-flex flex-column flex-sm-row justify-content-between shadow-box p-3 mb-3">
            <span>الجنسية: </span>
            <span>{employee.nationality || "لايوجد"}</span>
          </div>

          <div className="profile-info-row d-flex flex-column flex-sm-row justify-content-between shadow-box p-3 mb-3">
            <span> الميلاد: </span>
            <span>{formatDate(employee.birthDate) || "لايوجد"}</span>
          </div>

          <div className="profile-info-row d-flex flex-column flex-sm-row justify-content-between shadow-box p-3 mb-3">
            <span>رقم الهوية/الإقامة: </span>
            <span>{employee.idNumber}</span>
          </div>

          <div className="profile-info-row d-flex flex-column flex-sm-row justify-content-between shadow-box p-3 mb-3">
            <span>رقم الجوال: </span>
            <span>{employee.phone}</span>
          </div>

          <div className="profile-info-row d-flex flex-column flex-sm-row justify-content-between shadow-box p-3 mb-3">
            <span>الايميل: </span>
            <span>{employee.email}</span>
          </div>

          <div className="profile-info-row d-flex flex-column flex-sm-row justify-content-between shadow-box p-3 mb-3">
            <span>تاريخ التعيين: </span>
            <span>
              <span>{formatDate(employee.hireDate) || "لايوجد"}</span>
            </span>
          </div>

          <div className="profile-info-row d-flex flex-column flex-sm-row justify-content-between shadow-box p-3 mb-3">
            <span>الرقم الوظيفي: </span>
            <span>{employee.empNumber || "لايوجد"}</span>
          </div>

          
          <div className="d-flex">
          <ButtonComponent
              text="تحديث كلمة المرور"
              className="primary-bg mx-2"
              onClick={openPasswordUpdateForm}
            />
            <ButtonComponent
              text="تحديث بياناتي"
              className="primary-bg mx-2"
              onClick={handleEdit}
            />
            <ButtonComponent
              onClick={handleShow}
              text=" عرض بطاقتي التعريفية"
              className="secondary-bg text-light  mx-2"
            />
              <ButtonComponent
              text="طلباتي"
              className="primary-bg mx-2"
              onClick={()=>handleMyRequests(employee.id)}
            />
          </div>
        </div>
      </div>
      {show && (
        <div className="profile-custom-modal">
          <div className="profile-modal-content">
            {/* Check if there are multiple department positions */}
            {employee.deptPos?.length > 1 && !selectedDeptPos && (
              <div className="dept-pos-selection">
                <p>اختر قسمًا ومنصبًا لعرض البطاقة:</p>
                <select
                  onChange={(e) =>
                    handleSelectDeptPos(parseInt(e.target.value))
                  }
                  className="form-select w-100"
                >
                  <option value="">اختر القسم والمنصب</option>
                  {employee.deptPos.map((pos) => (
                    <option key={pos.deptPosId} value={pos.deptPosId}>
                      {pos.deptName} - {pos.posTitle}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Display card if a position is selected or there's only one */}
            {(selectedDeptPos || employee.deptPos?.length === 1) && (
              <div ref={cardRef}>
                <EmployeeCard
                  name={employee.name}
                  collegeDept={
                    selectedDeptPos?.deptName || employee.deptPos[0]?.deptName
                  }
                  position={
                    selectedDeptPos?.posTitle || employee.deptPos[0]?.posTitle
                  }
                  qualification={employee.qualification}
                  nationality={employee.nationality}
                  empNumber={employee.empNumber || "0000"}
                  hireDate={formatDate(employee?.hireDate)}
                  idNumber={employee.idNumber}
                />
              </div>
            )}

            <div className="profile-modal-buttons">
              <button
                className="btn print-btn primary-bg text-light"
                onClick={handlePrint}
                disabled={!selectedDeptPos && employee.deptPos?.length > 1}
              >
                طباعة
              </button>
              <button
                className="btn close-btn light-gray-bg"
                onClick={handleClose}
              >
                اغلاق
              </button>
            </div>
          </div>
        </div>
      )}

{showPasswordForm && (
  <div 
    ref={passwordFormRef}
  className="d-flex flex-row justify-content-center">
  <div className="shadow-box d-flex flex-column justify-content-center align-items-center w-50">
    <h4 className="mb-4 text-center">تحديث كلمة المرور</h4>

    <div className="form-group mb-3">
      <label className="mb-1">كلمة المرور الحالية :</label>
      <input
  type="text"
  className="form-control"
  value={currentPassword}
  onChange={(e) => setCurrentPassword(e.target.value)}
/>    
</div>

    <div className="form-group mb-3">
      <label className="mb-1">كلمة المرور الجديدة :</label>
      <input
  type="text"
  className="form-control"
  value={newPassword}
  onChange={(e) => setNewPassword(e.target.value)}
/>    </div>

    <div className="form-group mb-4">
      <label className="mb-1">تأكيد كلمة المرور :</label>
      <input
  type="text"
  className="form-control"
  value={confirmNewPassword}
  onChange={(e) => setConfirmNewPassword(e.target.value)}
/>    </div>

    <div className="d-flex justify-content-end">
      <button
        className="btn secondary-bg text-white ms-2 px-4"
        onClick={handleCancelPasswordUpdate}
      >
        إلغاء
      </button>
      <button
  className="btn primary-bg text-white px-4"
  onClick={handleUpdatePassword}
  disabled={resetLoading}
>
  {resetLoading ? "جاري التحديث..." : "تحديث"}
</button>
    </div>
    {resetError && (
  <div className="alert alert-danger mt-3 text-center">{resetError}</div>
)}
  </div>


  </div>

)}


    </div>
  );
};

export default EmpDisplayProfile;
